import { de } from "../i18n/de.js";
import type { Unit } from "../types/entities.js";
import type { Menge } from "./convert.js";

/**
 * Eine Menge, wie sie auf dem Telefon steht.
 *
 * Deutsche Schreibweise, höchstens zwei Nachkommastellen, und keine Null
 * hinter dem Komma: "1,5 kg", aber "2 Stück" und nicht "2,0 Stück".
 */
export function formatQuantity(menge: Menge): string {
  const einheit = menge.unit === null ? "" : kurz(menge.unit);
  if (menge.quantity === null) return einheit;

  const zahl = menge.quantity.toLocaleString("de-DE", { maximumFractionDigits: 2 });
  return einheit.length === 0 ? zahl : `${zahl} ${einheit}`;
}

/** Mehrere Gruppen nebeneinander: "3 Dosen und 400 g". */
export function formatQuantities(mengen: readonly Menge[]): string {
  const teile = mengen.map(formatQuantity).filter((teil) => teil.length > 0);
  if (teile.length <= 1) return teile[0] ?? "";
  return `${teile.slice(0, -1).join(", ")} und ${teile.at(-1) ?? ""}`;
}

/**
 * Die kurze Form einer Einheit für die Zeile im Laden.
 *
 * Bei g, kg, ml und l ist das Kürzel die übliche Schreibweise. Bei den
 * Gebinden nicht: "1 pkg" liest niemand, dort steht das ganze Wort.
 */
export function kurz(unit: Unit): string {
  const kuerzel: Partial<Record<Unit, string>> = { g: "g", kg: "kg", ml: "ml", l: "l" };
  return kuerzel[unit] ?? de.items.units[unit];
}
